/* Oplayce — zoom tactile de l'image produit (pincement à deux doigts, double-tap, glisser une fois zoomé)
   pour la modale plein écran (« image_zoom: lightbox »). Le thème ne propose sinon que le zoom natif du
   navigateur sur la page entière, qui reste actif après fermeture de la modale et donne une impression de
   zoom « figé » : on prend ici la main sur le geste, uniquement sur mobile/tablette tactile. */
window.OpZoom = (function () {
  var NOOP = { enable: function () {}, reset: function () {} };
  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return NOOP;

  var MIN_SCALE = 1;
  var MAX_SCALE = 4;
  var TAP_SCALE = 2.3;
  var DOUBLE_TAP_MS = 300;

  function clampPan(img, scale, x, y) {
    var w = img.offsetWidth,
      h = img.offsetHeight;
    var maxX = Math.max(0, (w * scale - w) / 2);
    var maxY = Math.max(0, (h * scale - h) / 2);
    return { x: Math.min(maxX, Math.max(-maxX, x)), y: Math.min(maxY, Math.max(-maxY, y)) };
  }

  function apply(img, scale, x, y, animate) {
    scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale));
    var pan = clampPan(img, scale, x, y);
    img.style.transition = animate ? 'transform 0.2s ease-out' : 'none';
    img.style.transform = scale > 1.001 ? 'translate(' + pan.x + 'px,' + pan.y + 'px) scale(' + scale + ')' : '';
    img.dataset.opScale = scale;
    img.dataset.opX = pan.x;
    img.dataset.opY = pan.y;
    img.classList.toggle('op-zoomed', scale > 1.001);
  }

  function reset(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    content.querySelectorAll('img').forEach(function (img) {
      apply(img, 1, 0, 0, false);
    });
  }

  function enable(modal) {
    if (modal.dataset.opZoomBound) return;
    modal.dataset.opZoomBound = '1';
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var pointers = {};
    var pointerCount = 0;
    var pinch = null; // { dist, scale, x, y }
    var pan = null; // { startX, startY, x, y }
    var lastTapTime = 0;
    var lastTapImg = null;

    function activeImg() {
      var active = content.querySelector(':scope > .active');
      return active && active.tagName === 'IMG' ? active : null;
    }

    content.addEventListener('pointerdown', function (e) {
      var img = activeImg();
      if (!img || e.target !== img) return;

      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      pointerCount = Object.keys(pointers).length;

      if (pointerCount === 2) {
        var ids = Object.keys(pointers);
        var p0 = pointers[ids[0]],
          p1 = pointers[ids[1]];
        pinch = {
          dist: Math.hypot(p0.x - p1.x, p0.y - p1.y) || 1,
          scale: parseFloat(img.dataset.opScale) || 1,
          x: parseFloat(img.dataset.opX) || 0,
          y: parseFloat(img.dataset.opY) || 0,
        };
        pan = null;
      } else if (pointerCount === 1) {
        var scale = parseFloat(img.dataset.opScale) || 1;
        if (scale > 1.001) {
          pan = { startX: e.clientX, startY: e.clientY, x: parseFloat(img.dataset.opX) || 0, y: parseFloat(img.dataset.opY) || 0 };
          try {
            img.setPointerCapture(e.pointerId);
          } catch (err) {}
        }

        var now = Date.now();
        if (lastTapImg === img && now - lastTapTime < DOUBLE_TAP_MS) {
          lastTapTime = 0;
          var rect = img.getBoundingClientRect();
          if (scale > 1.001) {
            apply(img, 1, 0, 0, true);
          } else {
            var offsetX = (rect.width / 2 - (e.clientX - rect.left)) * (TAP_SCALE - 1);
            var offsetY = (rect.height / 2 - (e.clientY - rect.top)) * (TAP_SCALE - 1);
            apply(img, TAP_SCALE, offsetX, offsetY, true);
          }
        } else {
          lastTapTime = now;
          lastTapImg = img;
        }
      }
    });

    content.addEventListener('pointermove', function (e) {
      if (!(e.pointerId in pointers)) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var img = activeImg();
      if (!img) return;

      if (pinch && pointerCount === 2) {
        var ids = Object.keys(pointers);
        var p0 = pointers[ids[0]],
          p1 = pointers[ids[1]];
        var dist = Math.hypot(p0.x - p1.x, p0.y - p1.y) || 1;
        var scale = pinch.scale * (dist / pinch.dist);
        apply(img, scale, pinch.x, pinch.y, false);
        e.preventDefault();
      } else if (pan && pointerCount === 1) {
        var dx = e.clientX - pan.startX;
        var dy = e.clientY - pan.startY;
        apply(img, parseFloat(img.dataset.opScale) || 1, pan.x + dx, pan.y + dy, false);
        e.preventDefault();
      }
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      pointerCount = Object.keys(pointers).length;
      if (pointerCount < 2) pinch = null;
      if (pointerCount === 0) pan = null;
    }
    content.addEventListener('pointerup', endPointer);
    content.addEventListener('pointercancel', endPointer);
  }

  return { enable: enable, reset: reset };
})();
